import { useMemo } from 'react'

interface UseConfigWithDynamicDataParams<T> {
    areaConfig: T
    jobs: unknown[]
    mapping: {
        areaMapping?: Record<string, unknown>
        genreMapping?: Record<string, unknown>
        positionMapping?: Record<string, unknown>
        [key: string]: unknown
    }
}

/**
 * 地域設定と動的データを統合したconfigWithDynamicDataを生成するカスタムフック
 * 
 * @param areaConfig - 地域固有の設定オブジェクト
 * @param jobs - 求人データの配列
 * @param mapping - 動的に取得されたマッピングデータ
 * @returns 統合された設定オブジェクト
 */
export const useConfigWithDynamicData = <T extends Record<string, any>>({
    areaConfig,
    jobs,
    mapping
}: UseConfigWithDynamicDataParams<T>) => {
    return useMemo(() => ({
        ...areaConfig,
        jobs,
        ...mapping
    }), [areaConfig, jobs, mapping])
}
